var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    viewBox: "0 0 255 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.124 254.249C197.333 254.249 254.249 197.333 254.249 127.124C254.249 56.9155 197.333 0 127.124 0C56.9155 0 0 56.9155 0 127.124C0 197.333 56.9155 254.249 127.124 254.249Z",
    fill: "#3B4A5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.124 239.913C189.416 239.913 239.913 189.416 239.913 127.124C239.913 64.8328 189.416 14.3356 127.124 14.3356C64.8328 14.3356 14.3356 64.8328 14.3356 127.124C14.3356 189.416 64.8328 239.913 127.124 239.913Z",
    fill: "#A5CCDF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3979_30962",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 226,
    height: 226
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.124 239.943C189.416 239.943 239.913 189.446 239.913 127.154C239.913 64.8627 189.416 14.3655 127.124 14.3655C64.8328 14.3655 14.3356 64.8627 14.3356 127.154C14.3356 189.446 64.8328 239.943 127.124 239.943Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3979_30962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.26824 3.33742L-276.748 103.392L-176.694 386.409L106.323 286.354L6.26824 3.33742Z",
    fill: "#92B9CC"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1905 57.4172H217.058C226.122 57.4172 233.484 64.7792 233.484 73.8435V196.831H20.7643V73.8435C20.7643 64.7792 28.1262 57.4172 37.1905 57.4172Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1905 52.1907H217.058C226.122 52.1907 233.484 59.5526 233.484 68.6169V81.8625H20.7643V68.6169C20.7643 59.5526 28.1262 52.1907 37.1905 52.1907Z",
    fill: "#EFE399"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3457 75.3293C65.8322 75.3293 67.8479 73.3136 67.8479 70.827C67.8479 68.3405 65.8322 66.3247 63.3457 66.3247C60.8591 66.3247 58.8434 68.3405 58.8434 70.827C58.8434 73.3136 60.8591 75.3293 63.3457 75.3293Z",
    fill: "#1C93C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4351 75.3293C50.9216 75.3293 52.9374 73.3136 52.9374 70.827C52.9374 68.3405 50.9216 66.3247 48.4351 66.3247C45.9485 66.3247 43.9328 68.3405 43.9328 70.827C43.9328 73.3136 45.9485 75.3293 48.4351 75.3293Z",
    fill: "#1C93C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5245 75.3293C36.0111 75.3293 38.0268 73.3136 38.0268 70.827C38.0268 68.3405 36.0111 66.3247 33.5245 66.3247C31.038 66.3247 29.0222 68.3405 29.0222 70.827C29.0222 73.3136 31.038 75.3293 33.5245 75.3293Z",
    fill: "#1C93C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.268 66.265H83.5574C80.8275 66.265 78.6146 68.478 78.6146 71.2078V71.2153C78.6146 73.9451 80.8275 76.1581 83.5574 76.1581H146.268C148.998 76.1581 151.211 73.9451 151.211 71.2153V71.2078C151.211 68.478 148.998 66.265 146.268 66.265Z",
    fill: "#1C93C6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7336 101.667H31.5608V164.423H92.7336V101.667Z",
    fill: "#D3D3D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.209 105.527H36.1005V145.966H88.209V105.527Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1509 137.454C68.5632 137.454 73.7613 132.256 73.7613 125.843C73.7613 119.431 68.5632 114.233 62.1509 114.233C55.7387 114.233 50.5405 119.431 50.5405 125.843C50.5405 132.256 55.7387 137.454 62.1509 137.454Z",
    fill: "#98364D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1312 125.843L59.2914 121.326V130.368L67.1312 125.843Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8252 150.535H36.2871V152.656H81.8252V150.535Z",
    fill: "#3B4A5C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.236 154.776H36.2871V156.897H53.236V154.776Z",
    fill: "#3B4A5C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.439 101.667H97.2659V164.423H158.439V101.667Z",
    fill: "#D3D3D3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M153.907 105.527H101.798V145.966H153.907V105.527Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M127.856 137.454C134.268 137.454 139.466 132.256 139.466 125.843C139.466 119.431 134.268 114.233 127.856 114.233C121.444 114.233 116.246 119.431 116.246 125.843C116.246 132.256 121.444 137.454 127.856 137.454Z",
    fill: "#98364D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M132.836 125.843L124.996 121.326V130.368L132.836 125.843Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.53 150.535H101.992V152.656H147.53V150.535Z",
    fill: "#3B4A5C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M118.941 154.776H101.992V156.897H118.941V154.776Z",
    fill: "#3B4A5C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.144 101.667H162.971V164.423H224.144V101.667Z",
    fill: "#D3D3D3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M219.612 105.527H167.503V145.966H219.612V105.527Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.553 137.454C199.966 137.454 205.164 132.256 205.164 125.843C205.164 119.431 199.966 114.233 193.553 114.233C187.141 114.233 181.943 119.431 181.943 125.843C181.943 132.256 187.141 137.454 193.553 137.454Z",
    fill: "#98364D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M198.534 125.843L190.701 121.326V130.368L198.534 125.843Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M213.235 150.535H167.697V152.656H213.235V150.535Z",
    fill: "#3B4A5C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M184.646 154.776H167.697V156.897H184.646V154.776Z",
    fill: "#3B4A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningResources);
export default __webpack_public_path__ + "static/media/learningResources.7442c94bd2163695cfc01966fb4e6176.svg";
export { ForwardRef as ReactComponent };